import React, { Suspense, lazy } from 'react';
import { StickyAlertBar } from '../components/StickyAlertBar';
import { HeroSection } from '../components/HeroSection';
/* Below-fold sections loaded lazily — reduces initial JS parse time */
const SalesLetter = lazy(() => import('../components/SalesLetter').then(m => ({
  default: m.SalesLetter
})));
const WhatYouGet = lazy(() => import('../components/WhatYouGet').then(m => ({
  default: m.WhatYouGet
})));
const BonusStack = lazy(() => import('../components/BonusStack').then(m => ({
  default: m.BonusStack
})));
const DynamicPricing = lazy(() => import('../components/DynamicPricing').then(m => ({
  default: m.DynamicPricing
})));
const SocialProofFooter = lazy(() => import('../components/SocialProofFooter').then(m => ({
  default: m.SocialProofFooter
})));
export function LandingPage() {
  return <div className="w-full min-h-screen" style={{
    background: 'var(--bg-page)',
    fontFamily: 'var(--font-body)'
  }} data-id="element-494">
      {/* A. Sticky Alert Bar — above fold, eager */}
      <StickyAlertBar data-id="element-495" />

      {/* B. Hero Section — above fold, eager */}
      <HeroSection data-id="element-496" />

      {/* C–G. Below-fold sections — lazy loaded */}
      <Suspense fallback={null} data-id="element-497">
        <div className="section-lazy" data-id="element-498">
          <SalesLetter data-id="element-499" />
        </div>
        <div className="section-lazy" data-id="element-500">
          <WhatYouGet data-id="element-501" />
        </div>
        <div className="section-lazy" data-id="element-502">
          <BonusStack data-id="element-503" />
        </div>
        <div className="section-lazy" data-id="element-504">
          <DynamicPricing data-id="element-505" />
        </div>
        <div className="section-lazy" data-id="element-506">
          <SocialProofFooter data-id="element-507" />
        </div>
      </Suspense>
    </div>;
}